import { useMutation } from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetOrCreateApplicationSectionVisitRequestObjectSchema,
  GetOrCreateApplicationSectionVisitRequestObjectType,
  GetOrCreateApplicationSectionVisitResponseSchema,
  GetOrCreateApplicationSectionVisitResponseType
} from '../../../services/NwApplicationServices/APIService/types';

import { useNwApplicationService } from '../useNwApplicationService';

interface UseGetOrCreateApplicationSectionVisitApiInterface {
  getOrCreateApplicationSectionVisitApi: (
    input: GetOrCreateApplicationSectionVisitRequestObjectType
  ) => Promise<GetOrCreateApplicationSectionVisitResponseType>;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: 'idle' | 'loading' | 'success' | 'error';
  reset: () => void;
}

const useGetOrCreateApplicationSectionVisitApi =
  (): UseGetOrCreateApplicationSectionVisitApiInterface => {
    const { nwApplicationService } = useNwApplicationService();

    const getOrCreateApplicationSectionVisit = (
      requestObject: GetOrCreateApplicationSectionVisitRequestObjectType
    ) => {
      try {
        GetOrCreateApplicationSectionVisitRequestObjectSchema.parse(
          requestObject
        );
      } catch (error) {
        console.error('Invalid request object:', error);
        throw error;
      }

      return nwApplicationService
        .getOrCreateApplicationSectionVisit(requestObject)
        .then((response) => {
          try {
            GetOrCreateApplicationSectionVisitResponseSchema.parse(response);
          } catch (error) {
            console.error('Invalid response object:', error);
            throw error;
          }
          return response;
        });
    };

    const { mutateAsync, isLoading, isError, error, status, reset } =
      useMutation(getOrCreateApplicationSectionVisit, {
        mutationKey: ['getOrCreateApplicationSectionVisitApi']
      });

    return {
      getOrCreateApplicationSectionVisitApi: mutateAsync,
      isLoading,
      isError,
      error: error ? getAPIErrorMessage(error) : null,
      status,
      reset
    };
  };

export { useGetOrCreateApplicationSectionVisitApi };
